import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import axiosInstance from "../../services/api";
import Select from "react-select";
import Loader from '../Commons/Loader';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { toast } from 'react-toastify';
import $ from "jquery";
import "jquery-ui-dist/jquery-ui.css";
import "jquery-ui-dist/jquery-ui";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    LabelList,
    LineChart, 
    Line,
  } from 'recharts';

function DashboardManagement() {
    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: "40px",
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
    };
    const datepickerRef = useRef();
    const [loading, setLoading] = useState(false);
    const [placeholder, setPlaceholder] = useState("Please Select Hotel Id");
    const [graphData, setGraphData] = useState([]);
    const [hotelListData, setHotelListData] = useState([]);
    const [hotelId, setHotelId] = useState("");
    const [propertyName, setPropertyName] = useState("");
    const [propertyHubRegistrationId, setPropertyHubRegistrationId] = useState("");

    const [reportData, setReportData] = useState("");
    const [dafaultDateText, setDafaultDate] = useState("");
    const [changeDate, setChangeDate] = useState(false);

    const sampleData = [
        { date: '2025-04-10', incidentCount: 2 },
        { date: '2025-04-11', incidentCount: 1 },
        { date: '2025-04-12', incidentCount: 6 },
        { date: '2025-04-13', incidentCount: 7 },
        { date: '2025-04-14', incidentCount: 3 },
        { date: '2025-04-12', incidentCount: 0 },
        { date: '2025-04-13', incidentCount: 4 },
        { date: '2025-04-14', incidentCount: 8 },
      ];

    //   useEffect(() => {
    //     // Ensure the ref is not null
    //     if (datepickerRef.current) {
    //         const today = new Date();
    //         const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1); // First day of current month
    //         const defaultDate = graphData?.summaryReport?.reportDate;
    
    //         // const formattedDefaultDate = new Date(defaultDate).toISOString().split('T')[0];
    //         // console.log(formattedDefaultDate, "defaultDate");
            
    //         setDafaultDate(defaultDate);



    //         // Initialize datepicker
    //         $(datepickerRef.current).datepicker("destroy").datepicker({
    //             dateFormat: "yy-mm-dd",
    //             minDate: firstDayOfMonth, // Allow only dates after or equal to the first day of the current month
    //             maxDate: 0,  // Allow only dates before or equal to the last day of the current month
    //             onSelect: function (dateText) {
    //                 // Handle date selection
    //                 console.log(dateText,"dateTextdateTextdateText")
    //                 setDafaultDate(dateText);
    //                 if (hotelId) {
    //                     fetchGraphData(hotelId); // Call fetchGraphData with the selected hotelId
    //                 }
    //             }
    //         });
    
    //         // If defaultDate exists, set it after initializing the datepicker
    //         if (defaultDate) {
    //             // Convert to the correct format if necessary (ensure it's "yyyy-mm-dd")
    //             const formattedDefaultDate = new Date(defaultDate).toISOString().split('T')[0];
    //             $(datepickerRef.current).datepicker('setDate', formattedDefaultDate);
    //         }
    //     }
    
    //     // Cleanup function to destroy the datepicker when the component unmounts
    //     return () => {
    //         if (datepickerRef.current) {
    //             $(datepickerRef.current).datepicker("destroy");
    //         }
    //     };
    // }, [graphData?.summaryReport?.reportDate, hotelId]);
    
    
    

    const graphRef = useRef();
    const handleDownloadPdf = async () => {
        try {
            setLoading(true); // Show loader

            const element = graphRef.current;

            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                scrollY: -window.scrollY
            });

            const imgData = canvas.toDataURL("image/jpeg", 1.0);

            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;

            // Convert px to jsPDF's internal unit (px by default, so it's fine)
            const padding = 20; // smaller padding to avoid right cutoff
            const pdfWidth = canvasWidth + padding * 2;
            const pdfHeight = canvasHeight + padding * 2;

            const pdf = new jsPDF({
                orientation: canvasWidth > canvasHeight ? "landscape" : "portrait",
                unit: "px",
                format: [pdfWidth, pdfHeight],
            });

            pdf.addImage(
                imgData,
                "JPEG",
                padding,
                padding,
                canvasWidth,
                canvasHeight
            );

            const hotelName = graphData?.summaryReport?.hotelName || "Hotel";
            
            // const now = new Date();
            // const formattedDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
            // const formattedTime = `${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
            // const timestamp = `${formattedDate}-${formattedTime}`;
            // const fileName = `Graph-${hotelName}-${timestamp}.pdf`;

            const hotelNameRaw = graphData?.summaryReport?.hubRegistrationId || "Hotel";

            // Convert hotel name: lowercase, remove commas, replace spaces with dashes
            const formattedHotelName = hotelNameRaw
            .toLowerCase()
            .replace(/,/g, '')          // Remove commas
            .replace(/\s+/g, '-');      // Replace spaces with dashes

            // Get date in YYYYMMDD format
            const now = new Date();
            // const formattedDate = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;
            const formattedDate = dafaultDateText.replace(/-/g, '');

            // Final filename
            const fileName = `${formattedHotelName}_${formattedDate}`;

            pdf.save(fileName);
        } catch (error) {
            console.error("Error generating PDF:", error);
        } finally {
            setLoading(false); // Hide loader
        }
    };

    // const handleDownloadPdf = async () => {
    //     try {
    //         setLoading(true); // Show loader
    
    //         const element = graphRef.current;
    //         const canvas = await html2canvas(element, { scale: 2 });
    //         const imgData = canvas.toDataURL("image/png");
    
    //         const padding = 40;
    //         const contentWidth = canvas.width;
    //         const contentHeight = canvas.height;
    
    //         const pdf = new jsPDF({
    //             orientation: "portrait",
    //             unit: "px",
    //             format: [contentWidth + padding * 2, contentHeight + padding * 2]
    //         });
    
    //         pdf.addImage(imgData, "PNG", padding, padding, contentWidth, contentHeight);
    
    //         const hotelName = graphData?.summaryReport?.hotelName || "Hotel";
    
    //         const now = new Date();
    //         const formattedDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    //         const formattedTime = `${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
    //         const timestamp = `${formattedDate}-${formattedTime}`;
    
    //         const fileName = `Graph-${hotelName}-${timestamp}.pdf`;
    
    //         pdf.save(fileName);
    //     } catch (error) {
    //         console.error("Error generating PDF:", error);
    //     } finally {
    //         setLoading(false); // Hide loader
    //     }
    // };
    

    const handleSelectChange = (e) => {
        console.log(e.label,"e.label")
        setHotelId(e.value);
        setPropertyName(e.label);
        if(!changeDate){
            fetchGraphData(e.value); // Call the API directly
        }
    };

    const fetchGraphData = async (hotelIdParam) => {
        //setLoading(true);
        try {
            const response = await axiosInstance.get('incidents/call-report',{
                params: {
                    hotelId: hotelIdParam, // sends ?hotelId=7
                    date: dafaultDateText
                }
            });
            const rawChartData = response.data.data.reportDetails; // replace with correct path
            const formattedData = formatGraphData(rawChartData);
            setReportData(response.data.data.disclaimerMessage)
            //console.log(formattedData,"formattedData")
            setGraphData({
                ...response.data.data,
                formattedChartData: formattedData
            });
        } catch (error) {
            console.error('Error fetching hotel data:', error);
        }
    };


    const fetchDataHotel = async () => {
        //setLoading(true);
        try {
            const response = await axiosInstance.get('hotel/all-hotels.json');
            setHotelListData(response.data.data || []);
        } catch (error) {
            console.error('Error fetching hotel data:', error);
        }
        // finally {
        //     setLoading(false);
        //     }
    };

    // useEffect(() => {
    //     fetchGraphData();
    //     fetchDataHotel();
    // }, []);

    useEffect(() => {
        const fetchAllData = async () => {
            setLoading(true);
            console.log("hello")
            try {
                await Promise.all([
                    fetchGraphData(),
                    fetchDataHotel()
                ]);
            } catch (err) {
                console.error("Error in initial data fetch:", err);
            } finally {
                setLoading(false);
            }
        };
    
        fetchAllData();
    }, []);
    

    useEffect(() => {
        if (graphData?.summaryReport?.hotelName) {
            setPropertyName(graphData.summaryReport.hotelName);
            setPropertyHubRegistrationId(graphData.summaryReport.hubRegistrationId)
        }
    }, [graphData]);

    const options = hotelListData.map((item) => ({
        value: item.id,
        label: item.hotelName,
    }));
        
    const formatGraphData = (rawData) => {
        const dateMap = {};
        //console.log(rawData,"rawData")
        rawData.forEach((item) => {
            //console.log(item,"item")
            const values = item.dateWiseValue;
            for (const date in values) {
                if (!dateMap[date]) {
                    dateMap[date] = 0;
                }
                dateMap[date] += values[date];
            }
        });
    
        const result = Object.entries(dateMap).map(([date, incidentCount]) => ({
            date,
            incidentCount
        }));
    
        return result;
    };
    useEffect(() => {
        if (graphData?.summaryReport?.hotelId) {
            setHotelId(graphData?.summaryReport?.hotelId);
        }
    }, [graphData?.summaryReport?.hotelId]);  
    
    // useEffect(() => {
    //     if (hotelId) {
    //         fetchGraphData(hotelId); // Fetch graph data when hotelId changes
    //     }
    // }, [hotelId]);

    useEffect(() => {
        if (hotelId && dafaultDateText && changeDate) {
            fetchGraphData(hotelId); // Fetch graph data when either hotelId or dafaultDateText changes
        }
    }, [hotelId, dafaultDateText]);


    useEffect(() => {
        if (datepickerRef.current) {
            const today = new Date();
            const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1); // First day of current month
            const defaultDate = graphData?.summaryReport?.reportDate;
    
            // Initialize the datepicker
            $(datepickerRef.current).datepicker("destroy").datepicker({
                dateFormat: "yy-mm-dd",
                minDate: firstDayOfMonth, // Allow only dates after or equal to the first day of the current month
                maxDate: 0,  // Allow only dates before or equal to the last day of the current month
                onSelect: (dateText) => {
                    setDafaultDate(dateText);
                    setChangeDate(true);
                }
            });
    
            // Set the default date if available
            if (defaultDate) {
                const formattedDefaultDate = new Date(defaultDate).toISOString().split('T')[0]; // Ensure correct format (yyyy-mm-dd)
                setDafaultDate(formattedDefaultDate); // Update the state before setting the date in the datepicker
                $(datepickerRef.current).datepicker('setDate', formattedDefaultDate); // Set the date in the datepicker
            }
        }
    
        // Cleanup the datepicker on component unmount
        return () => {
            if (datepickerRef.current) {
                $(datepickerRef.current).datepicker("destroy");
            }
        };
    }, [graphData?.summaryReport?.reportDate]); 
    
    
    
    const handleDownloadExcelSubmit = async (format) => {
        //e.preventDefault();
        setLoading(true);

        try {
            setLoading(true);
            const response = await axiosInstance.get(
                `incidents/export-report-current-month?hotelId=${hotelId}&sendToEmail=false`,
                {
                    responseType: "blob", // Handle binary data correctly
                    timeout: 120000, // Timeout set to 120 seconds (120000 ms)
                }
            );
            const contentType = response.headers["content-type"] || (format === "pdf" ? "application/pdf" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        
            // Create a Blob from the response data
            const blob = new Blob([response.data], { type: contentType });
        
            // Generate a temporary URL for the file
            const downloadUrl = window.URL.createObjectURL(blob);
        
            // Create a hidden <a> element to trigger the download
            const link = document.createElement("a");
            link.href = downloadUrl;

            // const today = new Date();
            // // Format date and time for file name
            // const formattedDate = today.toISOString().split('T')[0];
            // const hours = today.getHours().toString().padStart(2, '0');
            // const minutes = today.getMinutes().toString().padStart(2, '0');
            // const seconds = today.getSeconds().toString().padStart(2, '0');
            // const currentTime = `${formattedDate}-${hours}-${minutes}-${seconds}`;
        
            // const DownloadFileName = `Report-${propertyName}-${currentTime}.${format}`;
            // link.setAttribute("download", DownloadFileName);

            const today = new Date();

            // Format date as YYYYMMDD
            //const formattedDateXl = today.toISOString().split('T')[0].replace(/-/g, '');
            const formattedDateXl = dafaultDateText.replace(/-/g, '');
            // Format property name: lowercase, spaces/comma to hyphen/ignore
            const formattedPropertyXl = propertyHubRegistrationId
                .toLowerCase()
                .replace(/,|_/g, '')          // remove commas and underscores
                .replace(/\s+/g, '-')         // replace spaces with hyphens

            const DownloadFileName = `${formattedPropertyXl}_${formattedDateXl}.${format}`;

            link.setAttribute("download", DownloadFileName);

        
            document.body.appendChild(link);
            link.click();
        
            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.error("Error fetching report data:", error);
        } finally {
            setLoading(false);
        }
    };



    const handleEmailExcelSubmit = async (e) => {
        //e.preventDefault();
        setLoading(true);

        try {
            setLoading(true);
            const response = await axiosInstance.get(
                `incidents/export-report-current-month?hotelId=${hotelId}&sendToEmail=true`,
            );
            if (response.status === 200) {
                if(response.data.status.code===200) {
                    toast.success(response.data.status.message);
                }else{
                    toast.error(response.data.status.message);
                }
            }
            
        } catch (error) {
            console.error("Error fetching report data:", error);
        } finally {
            setLoading(false);
        }
    };

    // for testing
    // const summaryKeysToShow = [
    //     "MSR S/W H/W and Configuration",
    //     "Paused",
    //     "How to use Call",
    //     "HK/IT/Engineering issues",
    //     "Network"
    // ];

    const cleanedMessage = reportData.replace(/^\*+/, '').trim();

    return (
        <>
            {loading && <Loader />} 
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Dashboard Management</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Dashboard Management</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid border-top pt-4">
                    <div className="dashboard-mangement-top">
                        <div className='row items-center'>
                            <div className="col-lg-3 mb-mob">
                                <Select
                                    options={options}
                                    onChange={handleSelectChange}
                                    placeholder={placeholder}
                                    styles={customStyles}
                                    isSearchable
                                    noOptionsMessage={() => "No sub-hotels available"}
                                    value={options.find(opt => opt.label === graphData?.summaryReport?.hotelName) || null}
                                />
                            </div>
                            <div className="custom-with">
                                <input type="text" name="date" placeholder='Select Date' className='input-fld' ref={datepickerRef}/>
                                <span className="active-default-date">{dafaultDateText}</span>
                            </div>
                            <div className="col-lg-12 custom-with-btn">
                                <div className="btn-group-dashboard">
                                    <button className="btn btn-primary submit-btn" onClick={handleDownloadPdf}>Download Graph as pdf</button>
                                    <button className="btn btn-primary cancel-btn" onClick={() => handleDownloadExcelSubmit("xlsx")}>Download Excel Report</button>
                                    <button className="btn btn-primary submit-btn grey-btn" onClick={handleEmailExcelSubmit}>Email Excel Report</button>
                                    {/* <button className="btn btn-primary" onClick={handleDownloadPdf}>Download pdf</button> */}
                                </div>
                            </div>
                        </div>
                        <div ref={graphRef} className="pb-2">
                            <h3 className="dash-title">
                            {graphData?.summaryReport?.hotelName} call report{" "}
                            {graphData?.summaryReport?.observationTime && (() => {
                                const [obsDate, obsTime] = graphData.summaryReport.observationTime.split(" ");
                                const timeFormatted = obsTime.slice(0, 5); // "15:30"

                                const formatDateWithYear = (dateString) => {
                                    const dateObj = new Date(dateString);
                                    const day = dateObj.getDate();
                                    const month = dateObj.toLocaleString('default', { month: 'long' });
                                    const year = dateObj.getFullYear();
                                    const suffix = (day === 1 || day === 21 || day === 31) ? 'st' :
                                                (day === 2 || day === 22) ? 'nd' :
                                                (day === 3 || day === 23) ? 'rd' : 'th';

                                    return `${day}${suffix} ${month} ${year}`;
                                };

                                const formattedDefaultDate = formatDateWithYear(dafaultDateText);  // for 28th April 2025
                                const formattedObsDate = formatDateWithYear(obsDate);              // extracted at 29th April 2025

                                return `for ${formattedDefaultDate} extracted at ${formattedObsDate} ${timeFormatted}`;
                            })()}


                            </h3>
                            <div className="dashboard-table">
                                {/* for testing purpose */}
                                {/* <table className="table">
                                    <thead>
                                        <tr>
                                        <th>Owner Category</th>
                                        {summaryKeysToShow.map((key, index) => (
                                            <th key={index}>{key}</th>
                                        ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                        <td>Total Calls</td>
                                        {summaryKeysToShow.map((key, index) => (
                                            <td key={index}>{graphData?.summaryReport?.[key] ?? 0}</td>
                                        ))}
                                        </tr>
                                    </tbody>
                                </table> */}
                                {/* for testing purpose */}
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Owner Category</th>
                                            <th>MSR S/W, H/W & Configuration</th>
                                            <th>Paused</th>
                                            <th>How to use Call</th>
                                            <th>HK / Engineering Issues</th>
                                            <th>Network</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Total Calls</td>
                                            <td>{graphData?.summaryReport?.['MSR S/W H/W and Configuration']}</td>
                                            <td>{graphData?.summaryReport?.Paused}</td>
                                            <td>{graphData?.summaryReport?.['How to use Call']}</td>
                                            <td>{graphData?.summaryReport?.['HK/IT/Engineering issues']}</td>
                                            <td>{graphData?.summaryReport?.Network}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="dashboard-wrap dashboard-graph-section">
                                <div className="row">
                                    {graphData?.reportDetails?.length > 0 && graphData?.reportDetails?.map((item, index) => (
                                        <div className="col-lg-6 col-12 dashboard-main-blk" key={index}>
                                            {/* small box */}
                                            <div className="small-box bg-info bashboard-1">
                                            <div className="inner">
                                                <h3>{item.title}</h3>
                                                <div className='dashboard-inner-blk'>
                                                    <div className="w-full h-[280px] relative">
                                                        {/* <ResponsiveContainer width="100%" height="100%">
                                                            <BarChart
                                                                data={formatGraphData([item])}
                                                                margin={{ top: 20, right: 10, left: -30, bottom: 30 }}
                                                                barSize={20}
                                                            >
                                                                <CartesianGrid strokeDasharray="3 3" />
                                                                <XAxis 
                                                                    dataKey="date"  
                                                                    tick={{ fontSize: 10 }} 
                                                                    angle={-45} 
                                                                    textAnchor="end" 
                                                                    interval={0} 
                                                                    minTickGap={5}
                                                                />
                                                                <YAxis tick={{ fontSize: 10 }}/>
                                                                <Tooltip />
                                                                <Legend wrapperStyle={{ fontSize: 10 }}/>
                                                                <Bar dataKey="incidentCount" fill="#31a713" radius={[50, 50, 0, 0]}>
                                                                    <LabelList dataKey="incidentCount" position="top" fontSize={10} />
                                                                </Bar>
                                                            </BarChart>
                                                            <LineChart 
                                                                data={formatGraphData([item])}
                                                                margin={{ top: 20, right: 42, left: 60, bottom: 60 }}
                                                                barSize={20}
                                                            >
                                                                <Tooltip />
                                                                <Line type="monotone" dataKey="incidentCount" stroke="#31a713" />
                                                            </LineChart>
                                                        </ResponsiveContainer> */}
                                                        <ResponsiveContainer width="100%" height="100%">
                                                            <LineChart 
                                                                data={formatGraphData([item])}
                                                                margin={{ top: 20, right: 20, left: -20, bottom: 40 }}
                                                            >
                                                                <CartesianGrid strokeDasharray="" vertical={false} horizontal={true} />
                                                                
                                                                <XAxis 
                                                                dataKey="date"
                                                                tick={{ fontSize: 10, dy: 10 }}
                                                                angle={-45}
                                                                textAnchor="end"
                                                                interval={0}
                                                                minTickGap={5}
                                                                padding={{ left: 20, right: 20 }} // 👈 Horizontal space added
                                                                />
                                                                
                                                                <YAxis 
                                                                tick={{ fontSize: 10 }}
                                                                padding={{ top: 10 }}
                                                                domain={[0, 10]} 
                                                                tickCount={6}  
                                                                />
                                                                <Legend wrapperStyle={{ fontSize: 10 }} />
                                                                <Line 
                                                                type="monotone" 
                                                                dataKey="incidentCount" 
                                                                stroke="#31a713"
                                                                dot={{ r: 3 , fill: "#31a713"}}
                                                                activeDot={{ r: 5 }}
                                                                >
                                                                    <LabelList 
                                                                        dataKey="incidentCount" 
                                                                        position="top" 
                                                                        fontSize={10} 
                                                                        fill="#31a713"  // Set the color here
                                                                    />
                                                                </Line>
                                                            </LineChart>
                                                        </ResponsiveContainer>


                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="dashboard-table">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Ticket Status</th>
                                            <th>Suspended</th>
                                            <th>Open</th>
                                            <th>Close</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Total Calls</td>
                                            <td>{graphData?.currentDayTicketStatusSummary?.suspendedTickets}</td>
                                            <td>{graphData?.currentDayTicketStatusSummary?.openTickets}</td>
                                            <td>{graphData?.currentDayTicketStatusSummary?.closedTickets}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <i className="report-note"><span>*</span> {cleanedMessage}</i>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default DashboardManagement;
